import Vue from 'vue';
import { cloneDeep } from 'lodash';

// No.9 代行者管理 一覧：検索・ページング・ソート状態（cmsUserSearch.js 踏襲）
const INIT_DATA = {
  currentPage: 1,
  perPage: 10,
  totalRows: 0,
  // フィルタリング条件（報告管理一覧に準拠＋代行者特有）
  filter: {
    code: '',
    name: '',
    agentName: '',
    // 代行者の設定有無（null=未選択／1=あり／0=なし）
    hasAgent: null,
    // null=未選択（初回に最新年度を自動セット・申請/選考/報告 各一覧と同作法）／'all'=すべて（明示選択）
    year: null,
    series: null,
  },
  // 既定は報告者名（カナ順）昇順＝報告管理一覧と同作法
  sortBy: 'applicantKana',
  sortDesc: false,
};

export default {
  namespaced: true,
  state: cloneDeep(INIT_DATA),
  mutations: {
    setFilter(state, param) {
      Vue.set(state.filter, param.key, param.value);
      // 絞り込み条件が変わったら1ページ目に戻す（空ページ表示の回避）
      state.currentPage = 1;
    },
    setCurrentPage(state, page) {
      state.currentPage = page;
    },
    setPerPage(state, page) {
      state.perPage = page;
      state.currentPage = 1;
    },
    setTotalRows(state, value) {
      state.totalRows = value;
    },
    initFilter(state) {
      Vue.set(state, 'filter', cloneDeep(INIT_DATA.filter));
      state.currentPage = 1;
      state.perPage = 10;
      state.sortBy = 'applicantKana';
      state.sortDesc = false;
    },
    setSortBy(state, v) {
      state.sortBy = v;
    },
    setSortDesc(state, v) {
      state.sortDesc = v;
    },
  },
  actions: {
  },
};
